import { GeneralService } from 'src/app/services/general.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import {
  DropDownListDTO,
  DropDownListSiteRecebimentoDTO,
} from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormAreaTypesService } from './../../../../services/form.area.types.service';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-classificacao-II',
  templateUrl: './cd001-card-classificacao-II.component.html',
})
export class Cd001CardClassificacaoIIComponent
  extends GeneralComponent
  implements OnInit, OnChanges
{
  public formulario?: FormGroup;
  public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> =
    new Array<DropDownListSiteRecebimentoDTO>();
  public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public filteredOptionsSiteRecebimento: Observable<
    DropDownListSiteRecebimentoDTO[]
  >;
  public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;

  @Output() mkCalc = new EventEmitter();
  @Input() generationValue: number = 0;
  public isReadOnlyRetidoPeneiraTrezeMeioPrc: boolean;
  public isReadOnlyRetidoPeneiraTrezePrc: boolean;
  public isReadOnlyRetidoPeneiraDozeMeioPrc: boolean;
  public isReadOnlyRetidoPeneiraDozePrc: boolean;
  public isReadOnlyRetidoPeneiraOnzeMeioPrc: boolean;




  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService
  ) {
    super('Peneiras de Furo Oblongo (% de Retido)', false);
    if(this.isComercial){
      this.formulario = this.formBuilder.group({
      retido_peneira_treze_meio_prc: [null, []],
      retido_peneira_treze_prc: [null, []],
      retido_peneira_doze_meio_prc: [null, []],
      retido_peneira_doze_prc: [null, []],
      retido_peneira_onze_meio_prc: [null, []],
      vazado_peneira_corresp_oblongo_prc: [null, []],
    });
  } else {
    this.formulario = this.formBuilder.group({
      //retido_peneira_treze_meio_prc: [null, []],
      //retido_peneira_treze_prc: [null, []],
      //retido_peneira_doze_meio_prc: [null, []],
      //retido_peneira_doze_prc: [null, []],
      //retido_peneira_onze_meio_prc: [null, []],
      //vazado_peneira_corresp_oblongo_prc: [null, []],
    });

  }

}

  public async ngOnInit(): Promise<void> {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.generationValue === 1) {
      this.formulario.disable();
    } else {
      this.formulario.enable();
    }
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }
}
